import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select'
import { Button, CloseButton, DrawerBody, DrawerContainer, DrawerFooter, DrawerHead } from './style'
import { AddIcon, CloseIcon, DeleteIcon, FilterIcon } from '../../../icons'
import { Overlay } from '../list/manage/styles'
import { useTranslation } from 'react-i18next'
import SelectReact from '../selectReact'

const CustomOption = (props) => {
    const { data } = props;
    const [t] = useTranslation();
  
    return (
      <components.Option {...props}>
        {/* Customize how each option looks */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* You can add icons or additional info here */}
          <FilterIcon />
          <span>{t(data.label)}</span>
        </div>
      </components.Option>
    );
  };

const Drawer = ({setShowDrawer,formInput,filterView,setFilterView,onChange}) => {

    const [t] = useTranslation();
    const [selectedFilter, setSelectedFilter] = useState([]);
    const [filterInput, setFilterInput] = useState([]);
    const [addFilter, setAddFilter] = useState(false);
    const [availableFilters, setAvailableFilters] = useState([]); // To hold unselected filters
    const [isFirstTimeOpen, setIsFirstTimeOpen] = useState(true);
    const [selectFilterView, setSelectFilterView] = useState(filterView); 

    useEffect(() => {
        if (formInput.length > 0) {
            let val = formInput.filter((item) => item.type === "select" && (item.filter ?? true) === true);
            setFilterInput(val); // Initialize available filters
        }
    }, [formInput]);

    useEffect(() => {
        let selected = [...selectedFilter]
        let avSelected = [...availableFilters]
        filterInput.forEach(element => {
            if(element.filterType === "multiSelect") {
                if(filterView[element.name]?.length > 0) {
                    if(!selected.find(item => item.name===element.name)) {
                        selected.push(element);
                        avSelected.filter(filter => filter.name !== element.name);
                    }
                }
                else{
                    if(!avSelected.find(item => item.name===element.name))
                        avSelected.push(element);
                }
            }
            else{
                if(filterView[element.name]?.length > 0 && filterView[element.name] !== "") {
                    if(!selected.find(item => item.name===element.name)) {
                        selected.push(element);
                        avSelected.filter(filter => filter.name !== element.name);
                    }
                }
                else{
                    if(!avSelected.find(item => item.name===element.name))
                        avSelected.push(element);
                }
            }
        })
        setSelectedFilter(selected);
        setAvailableFilters(avSelected)
    }, [filterView,filterInput])

    const handleAddFilter = () => {
        setAddFilter(true);
        setIsFirstTimeOpen(true); // Open dropdown on first interaction
    };

    const handleFilterSelect = (selected) => {
        setSelectedFilter([...selectedFilter, selected]);
        setAvailableFilters(availableFilters.filter(filter => filter.name !== selected.name)); // Remove selected from available
        setAddFilter(false); // Close dropdown after selecting a filter
    };

    const handleFilterDelete = (selected) => {
        setSelectedFilter((filter) => filter.filter((item) => item.name !== selected.name));
        setAvailableFilters([...availableFilters, selected]);
        setAddFilter(false); // Close dropdown after selecting a filter
        setSelectFilterView({...selectFilterView, [selected.name]: formInput.find((item) => item.name === selected.name).defaultValue});
    };

    const handleFilterChange = (option, filter) => {
        // console.log(option);
        // let items = selectFilterView[filter.name];
        // if (Array.isArray(items)) {
        //   const index = items.findIndex((item) => item === option.label);
        //   if (index === -1) {
        //     // If option._id doesn't exist, push it to the items array
        //     items.push(option.label);
        //   } else {
        //     // If option._id already exists, remove it from the items array
        //     items.splice(index, 1);
        //   }
        //   const updateValue = {
        //     ...filterView,
        //     [filter.name]: items,
        //   };
        //   setSelectFilterView(updateValue);
        // } else {
        //   const updateValue = {
        //     ...filterView,
        //     [filter.name]: option.label,
        //   };
        //   setSelectFilterView(updateValue);
        // }
        if(Array.isArray(option)){
            setSelectFilterView({...selectFilterView, [filter.name]: option.map(item => item.label)});
        }
        else{
            setSelectFilterView({...selectFilterView, [filter.name]: option.label});
        }
    };

    // const filterChange = (sl, option, name) => {
    //     let items = filterView[name];
    //     if (Array.isArray(items)) {
    //       const index = items.findIndex((item) => item === option.id);
    //       if (index === -1) {
    //         // If option._id doesn't exist, push it to the items array
    //         items.push(option.id);
    //       } else {
    //         // If option._id already exists, remove it from the items array
    //         items.splice(index, 1);
    //       }
    //       const updateValue = {
    //         ...filterView,
    //         [name]: items,
    //       };
    //       setFilterView(updateValue);
    //     } else {
    //       const updateValue = {
    //         ...filterView,
    //         [name]: option.id,
    //       };
    //       setFilterView(updateValue);
    //     }
    //   };

    const handleMenuClose = () => {
        setAddFilter(false);
        setIsFirstTimeOpen(false); // Ensure dropdown doesn't stay open after first interaction or manual close

    };

    const handleFilterApply = () => {
        setFilterView(selectFilterView);
        setShowDrawer(false);
    }

    return (
        <Overlay>
            <DrawerContainer>
                <div style={{height:'100%',position:'relative'}}>
                <DrawerHead>
                    <div>{t("filter")}</div>
                    <CloseButton onClick={() => setShowDrawer(false)}>
                        <CloseIcon />
                    </CloseButton>
                </DrawerHead>
                <DrawerBody>
                    {selectedFilter.map((filter, index) => (
                        <SelectReact index={index} filter={filter} handleFilterDelete={handleFilterDelete} value={selectFilterView[filter.name]} handleFilterChange={handleFilterChange} selectFilterView={selectFilterView} />
                    ))}
                    
                    {addFilter ? (
                        <Select
                        options={availableFilters}
                        onChange={(selected) => handleFilterSelect(selected)}
                        menuIsOpen={isFirstTimeOpen}  // Auto-open the dropdown only on first interaction
                        autoFocus={isFirstTimeOpen}  // Auto-focus on the input field when first opening
                        onMenuClose={handleMenuClose}  // Handle manual closing of the dropdown
                        components={{ Option: CustomOption }}
                        placeholder={t("select")}
                    />

                    ) : <Button onClick={handleAddFilter} style={{marginBottom:'20px'}}>
                    <FilterIcon />
                    <span>{t("add filter")}</span>
                </Button>}
                    
                    
                </DrawerBody>
                <DrawerFooter>
                <Button style={{background: "#b8d2fa"}} onClick={handleFilterApply}>
                    <FilterIcon />
                    <span>{t("apply filter")}</span>
                </Button>
                </DrawerFooter>
                </div>
            </DrawerContainer>
        </Overlay>
    );
};

export default Drawer;
